import { Suspense, lazy } from 'react';
import { DendromapLoader } from '@repo/ui/components/dendromap-loader';

const PaymentStatsPage = lazy(() =>
  import('@repo/ui/features/payment-stats/payment-stats-page').then((module) => ({
    default: module.PaymentStatsPage,
  })),
);

export default function PaymentStatsDebugRoute() {
  return (
    <Suspense
      fallback={
        <DendromapLoader message="Chargement des statistiques paiements..." />
      }
    >
      <PaymentStatsPage />
    </Suspense>
  );
}
